"use client";
import Link from "next/link";
import Image from "next/image";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { usePath } from "@/app/contexts/PathContext";

export default function Footer() {
  const { color } = usePath();
  const footerStyle = { backgroundColor: color };
  return (
    <footer
      style={footerStyle}
      className="mt-auto py-7 text-white grid gap-6 justify-center justify-items-center"
    >
      <figure className="w-[120px]">
        <Image
          src="/assets/logo/parttime_logo_f.svg"
          width={100}
          height={100}
          alt="派派"
        />
      </figure>
      <div className="policy-links flex font-[500] text-[1rem] gap-6">
        <Link href="/privacy" className="hover:text-yellow-200">
          隱私權政策
        </Link>
        <Link href="/tos" className="hover:text-yellow-200">
          服務條款
        </Link>
      </div>
      <ul className="flex gap-4">
        <li>
          <Link
            href="https://www.facebook.com/paipai.tw"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white inline-block rounded-full px-1.5 py-1.5 hover:opacity-80"
            aria-label="Facebook"
          >
            <FaFacebookF size={22} color={color} />
          </Link>
        </li>
        <li>
          <Link
            href="https://www.instagram.com/paipai_tw/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white inline-block rounded-full px-1.5 py-1.5 hover:opacity-80"
            aria-label="Instagram"
          >
            <FaInstagram size={22} color={color} />
          </Link>
        </li>
        <li>
          <Link
            href="https://www.youtube.com/@paipai_tw"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white inline-block rounded-full px-1.5 py-1.5 hover:opacity-80"
            aria-label="YouTube"
          >
            <FaYoutube size={22} color={color} />
          </Link>
        </li>
      </ul>
      <p className="text-center">
        客服信箱 |{" "}
        <a
          href="mailto:service@ptm.works"
          className="hover:text-yellow-200 hover:underline"
          title="寄信給我們"
        >
          service@ptm.works
        </a>
        <br></br>
        <span>就業服務機構許可 基府社關壹字第1130238799號</span>
      </p>
      <p className="text-sm">Copyright © 2025 vibot is proudly powered by.</p>
    </footer>
  );
}
